import { Link } from 'react-router-dom';
import MovieCard from '@/components/base/MovieCard';
import { movies } from '@/mocks/movies';

const newMovies = [...movies].filter((m) => m.isNew).slice(0, 8);

export default function LatestMovies() {
  return (
    <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-lg md:text-xl font-heading font-bold text-foreground-50">
            最新上映
          </h2>
          <p className="text-xs text-foreground-500 mt-1">刚刚上线的高清热播电影</p>
        </div>
        <Link
          to="/category/dongzuo"
          className="text-xs text-primary-500 hover:text-primary-400 transition-colors flex items-center gap-1"
        >
          查看全部
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
        {newMovies.map((movie) => (
          <MovieCard key={movie.id} movie={movie} />
        ))}
      </div>
    </section>
  );
}